export const orderConstants = {
  GET_ORDERS: "GET_ORDERS",
  GET_ORDERS_BY_ID: "GET_ORDERS_BY_ID",
  GET_PRODUCTS_BY_ORDERS_ID: "GET_PRODUCTS_BY_ORDERS_ID",
  GET_CUSTOMER_BY_ID: "GET_CUSTOMER_BY_ID",
  ADD_REFUND: "ADD_REFUND",
  GET_ORDER_TOTAL: "GET_ORDER_STATUSES",
  REFUND_SUCCESS: "REFUND_SUCCESS",
  RESET_REFUND_SUCCESS: "RESET_REFUND_SUCCESS",
  CURRENCY_CODE: "CURRENCY_CODE",
};
